var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-mini/magnifying-glass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.55365C5.96243 3.55365 3.5 6.01608 3.5 9.05365C3.5 12.0912 5.96243 14.5536 9 14.5536C10.519 14.5536 11.893 13.9389 12.8891 12.9427C13.8852 11.9466 14.5 10.5726 14.5 9.05365C14.5 6.01608 12.0376 3.55365 9 3.55365ZM2 9.05365C2 5.18766 5.13401 2.05365 9 2.05365C12.866 2.05365 16 5.18766 16 9.05365C16 10.7162 15.4197 12.2442 14.4517 13.4447L17.7803 16.7733C18.0732 17.0662 18.0732 17.5411 17.7803 17.834C17.4874 18.1269 17.0126 18.1269 16.7197 17.834L13.3911 14.5054C12.1906 15.4733 10.6625 16.0536 9 16.0536C5.13401 16.0536 2 12.9196 2 9.05365Z",
    fill: "#334041"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.5a2d72207721fba99227d4d1afc97a4d.svg";
export { ForwardRef as ReactComponent };